import { createSelector } from "reselect";
import { dataSelector } from "src/selectors/data_selectors/data_selector";

export const populationIncidencePrevalenceChartDataSelector = createSelector(
  dataSelector,
  data => data.populationIncidencePrevalenceChartData
);
